module.exports = __webpack_public_path__ + "files/3500f1ec7fef624a0b7d145af2b693ac.png";